import { CloseConfig, DeepPartial } from '@empathybroker/ebx-gluon';

export const MOBILE_CLOSE_CONFIG: DeepPartial<CloseConfig> = {
  components: { icon: 'TuandcoCloseIcon' }
};
